import { getPageDataApi } from "../../Utils/commonApi";
import useBaseActions from "./base.actions";
import { BASE_API_PATHS } from "../../constants/apis.constants";

const useSubscriptionActions = () => {
  const { authTokens } = useBaseActions();

  const getSubscriptionOverview = ({ fromDate, endDate }) => {
    return getPageDataApi(BASE_API_PATHS.overviewDashboard, authTokens, {
      fromDate,
      endDate,
      accountType: 0,
      period: 'Current Year',
    });
  }

  const extendTrialPeriod = ({ accountId, subscriptionId, days, reason }) => {
    return getPageDataApi(BASE_API_PATHS.extendTrialPeriod, authTokens, {
      objId_Customer: accountId,
      objId_subscription: subscriptionId,
      days,
      reason,
    });
  }

  return {
    getSubscriptionOverview,
    extendTrialPeriod
  }
}

export default useSubscriptionActions;